import { render, staticRenderFns } from "./IrregularModal.vue?vue&type=template&id=2205b7e8"
import script from "./IrregularModal.vue?vue&type=script&lang=js"
export * from "./IrregularModal.vue?vue&type=script&lang=js"
import style0 from "./IrregularModal.vue?vue&type=style&index=0&id=2205b7e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports